import React from 'react';

export const Forbidden = () => {
  return (
    <h1>This resource is not available.</h1>
  )
};

export default Forbidden;
